export const formatAuthorBotMemory = (items = []) => {
    if (!Array.isArray(items) || items.length === 0) return '';

    const blocks = items
        .filter((item) => item?.correction)
        .map((item, index) => {
            const heading = item.kind === 'canon_correction'
                ? `Canon Correction ${index + 1}: ${item.title}`
                : `Writing Instruction ${index + 1}: ${item.title}`;
            const assumption = item.wrongAssumption
                ? `Wrong assumption: ${item.wrongAssumption}`
                : '';
            const correction = `Use this instead: ${item.correction}`;

            return [heading, assumption, correction].filter(Boolean).join('\n');
        });

    return blocks.join('\n\n');
};
